import './DualEsriView.scss';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { DualEsriViewModel } from './DualEsriViewModel';
import { EsriViewHost } from '../EsriViewHost/EsriViewHost';
import Draggable from 'react-draggable';
import stores from 'cd-eft/models/Stores';

const { designStore } = stores.AppStore;

// interface declaring the expected component props
interface IDualEsriViewProps {
  vm: DualEsriViewModel | undefined;
}

// primary component definition
export const DualEsriView = observer((props: IDualEsriViewProps) => {
  // if props.vm is not supplied, render a crippled version of the component
  if (!props.vm) {
    return <div className="eft-dualesriview" style={{ display: 'none' }} data-testid="eft-dualesriview-no-vm" />;
  }

  // if props.vm is supplied, render the component
  const vm = props.vm;
  const viewStyle: string = vm.viewStyle;
 return (
  <div className="eft-dualesriview" data-testid="eft-dualesriview">
    <div className={`eft-${viewStyle}-primary`} data-testid={`eft-${viewStyle}-primary`}>
      <EsriViewHost esriView={vm.primaryView} />
    </div>
    {!designStore.toggle3DMap && (
      <Draggable
        axis="both"
        handle=".handle"
        defaultPosition={{ x: 0, y: 0 }}
        // bounds=".design-workspace"
        grid={[25, 25]}
      >
        <div className={`eft-${viewStyle}-secondary1 handle`} data-testid={`eft-${viewStyle}-secondary1`}>
          <div className={`eft-${viewStyle}-secondary2 handle`} data-testid={`eft-${viewStyle}-secondary2`}>
            <EsriViewHost esriView={vm.secondaryView} />
          </div>
        </div>
      </Draggable>
    )}
  </div>
);
});

export default DualEsriView;
